if (!customElements.get('schock-guide-carousel')) {
  customElements.define('schock-guide-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-guide-track]');
      this.prev = this.querySelector('[data-guide-prev]');
      this.next = this.querySelector('[data-guide-next]');
      this.page = this.querySelector('[data-guide-page]');
      if (!this.track || this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.prev.hidden = this.next.hidden = false;
      this.prev.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
      this.track.addEventListener('keydown', (event) => {
        if (event.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        this.move(event.key === 'ArrowRight' ? 1 : -1);
      }, options);
      this.resize = new ResizeObserver(() => this.update());
      this.resize.observe(this.track);
      this.update();
    }
    update() {
      const cards = this.track.children;
      if (!cards.length) return;
      const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
      this.step = cards[0].getBoundingClientRect().width + gap;
      this.visible = Math.max(1, Math.round((this.track.clientWidth + gap) / this.step));
      this.prev.disabled = this.track.scrollLeft < 2;
      this.next.disabled = this.track.scrollLeft >= this.track.scrollWidth - this.track.clientWidth - 2;
      const first = Math.round(this.track.scrollLeft / this.step) + 1;
      this.page.textContent = `${first}–${Math.min(cards.length, first + this.visible - 1)} / ${cards.length}`;
    }
    move(direction) {
      this.track.scrollBy({ left: direction * this.step * this.visible,
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.resize?.disconnect();
    }
  });
}
